import { Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useEffect, useRef, useState } from "react";
import FloatingWidgets from "./components/FloatingWidgets";
import SeoHelmet from "./components/SeoHelmet";

const fallbackStoreLocations = [
  {
    name: "Kalavasal",
    district: "Madurai",
    img: "assets/img/a1-img/map/A1_kalavasal_loc.jpg",
    link: "https://maps.app.goo.gl/w26rYpYzEqRjMqCz9",
    address:
      "Door No 73, Shop No G6 Service Rd, Bypass Rd, opp to Supreme Mobiles, Chokkalinga Nagar, Ponmeni, Madurai, Tamil Nadu 625016",
    phone: "7868066774",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Peraiyur",
    district: "Madurai",
    img: "https://res.cloudinary.com/dsdxwhpuu/image/upload/v1788342632/peraiyur_ztsie8.jpg",
    link: "https://maps.app.goo.gl/SK5X8CrHsCfCnjt59",
    address:
      "Usilampatti Main Road, Near to the bus stand, Peraiyur, Tamil Nadu, 625703",
    phone: "8428446136",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Samayanallur",
    district: "Madurai",
    img: "https://res.cloudinary.com/dsdxwhpuu/image/upload/v1788342631/samayanallur_l1xfti.jpg",
    link: "https://maps.app.goo.gl/BcaSpuKLwD83Ep4X7",
    address:
      "Chellam Complex, Madurai - Dindigul Rd, near by bus stop, Oormechikulam, Samayanallur, Madurai, Tamil Nadu 625402",
    phone: "9363071139",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Simmakal",
    district: "Madurai",
    img: "https://res.cloudinary.com/dsdxwhpuu/image/upload/v1788342631/simakkal_thcdnw.jpg",
    link: "https://maps.app.goo.gl/zRp1iguVocZcr9WG7",
    address:
      "77, Bus Stand Road, Arajar Salai, Simmakkal, Madurai Main, Madurai, Tamil Nadu 625001",
    phone: "9626322024",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Usilampatti",
    district: "Madurai",
    img: "assets/img/a1-img/map/A1_usilampatti_loc.jpg",
    link: "https://maps.app.goo.gl/AcE7sbQCCKnSrHU49",
    address:
      "Bus Depo, 99/100, Kochi-Madurai-Tondi Point Rd, opp. Royal Enfield Showroom, Sathya Nagar, Usilampatti, Tamil Nadu 625532",
    phone: "7550309803",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "T.Kallupatti",
    district: "Madurai",
    img: "https://res.cloudinary.com/dsdxwhpuu/image/upload/v1788342768/copy_of_tkallupatti_d9bzwa.jpg",
    link: "https://maps.app.goo.gl/xLMbDqJyGZrfDqgB9",
    address: "T.Kallupatti, Tamil Nadu 625702",
    phone: "8667351808",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Athipatti",
    district: "Viruthunagar",
    img: "https://res.cloudinary.com/dsdxwhpuu/image/upload/v1788342632/athipatti_awfsba.jpg",
    link: "https://maps.app.goo.gl/JGEQQ2mWV2VwgUFu8",
    address: "Vandapuli Rd, Athipatti, Tamil Nadu 625705",
    phone: "9751815011",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Kappalur Toll Plaza",
    district: "Madurai",
    img: "https://res.cloudinary.com/dsdxwhpuu/image/upload/v1788342632/kappalur_toll_dbpxpx.jpg",
    link: "",
    address: "Near Kappulur Toll Plaza",
    phone: "6381167583",
    timing: "7:00AM - 10:00PM",
  },
  {
    name: "Krishnakovil",
    district: "Viruthunagar",
    img: "assets/img/a1-img/map/A1_krishnankovil_loc.jpg",
    link: "https://maps.app.goo.gl/XkWm9yMQAVRu1JG79",
    address: "Krishnan Kovil, Tamil Nadu 626126",
    phone: "8940600701",
    timing: "7:00AM - 10:00PM",
  },
];

const ProductSectionHeader = ({
  title,
  viewAllLink = "/contact-us",
  subtitle,
}) => (
  <div className="row align-items-end mb-40">
    <div className="col-xl-6 col-lg-6">
      <div className="bd-section__title-wrapper">
        <h2 className="bd-section__title">{title}</h2>
        {subtitle && <p className="mb-0 mt-10 text-muted">{subtitle}</p>}
      </div>
    </div>
    <div className="col-xl-6 col-lg-6 d-flex justify-content-lg-end">
      <div className="bd-section__arrow text-lg-end mb-10">
        <Link to={viewAllLink}>
          View All <i className="fa-regular fa-angle-right"></i>
        </Link>
      </div>
    </div>
  </div>
);

export default function AboutUs() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [storeLocations] = useState(fallbackStoreLocations);

  const handleTogglePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  useEffect(() => {
    let swiperInstance = null;
    const timer = setTimeout(() => {
      const el = document.querySelector(".bd-map-active");
      if (window.Swiper && el) {
        swiperInstance = new window.Swiper(".bd-map-active", {
          slidesPerView: 4,
          spaceBetween: 30,
          loop: false,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".map-button-next",
            prevEl: ".map-button-prev",
          },
          breakpoints: {
            1200: { slidesPerView: 3 },
            992: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          },
        });
      }
    }, 300);

    return () => {
      clearTimeout(timer);
      if (swiperInstance && typeof swiperInstance.destroy === "function") {
        swiperInstance.destroy(true, true);
      }
    };
  }, []);

  return (
    <>
      <div>
        <SeoHelmet
          title="About Us | A1 Bakery & Sweets"
          description="From signature sweets and fresh bakery delights to wholesome vegetarian meals and handcrafted snacks, our mission is simple: deliver premium quality with the warmth of traditional hospitality."
          keywords="A1 Bakery and Sweets, Sweet Subbu, about A1 bakery, Madurai sweets, Virudhunagar bakery, Surya bakery history"
        />
        <Navbar />

        <header className="header-about">
          <div className="header-content">
            <div className="breadcrumb__list mb-20">
              <span>
                <Link to="/">Home</Link>
              </span>
              <span className="dvdr">
                <i className="fa-regular fa-angle-right"></i>
              </span>
              <span>About Us</span>
            </div>
            <h1>Every sweet tells a story. Every snack carries a memory</h1>
            <p>Every sweet tells a story. Every snack carries a memory.</p>
          </div>
        </header>

        <main className="about-container mt-90">
          <div className="container px-5">
            <div className="row">
              <section className="styled-grid">
                <div className="grid-item large">
                  <img src="/assets/img/a1-img/about__us/branch_1.png" alt="A1 Bakery Branch" />
                </div>

                <div className="grid-item">
                  <img
                    src="/assets/img/a1-img/about__us/branch_pro_3.png"
                    alt="A1 Sweets"
                  />
                </div>

                <div className="grid-item">
                  <img src="/assets/img/a1-img/about__us/branch_2.png" alt="A1 Bakery Counter" />
                </div>
              </section>
            </div>
          </div>

          <section className="timeline-table bg-light d-flex mt-40">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" colSpan="2" className="fs-3 fw-bold text-center pb-3">
                    Our Milestones
                  </th>
                </tr>
                <tr>
                  <th scope="col">Milestone</th>
                  <th scope="col">Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>2008</strong>
                    <div className="text-muted small">Founded</div>
                  </td>
                  <td>
                    Surya Bakery was established in Peraiyur, laying the foundation for our journey in quality baking.
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Rebranding</strong>
                    <div className="text-muted small">New Identity</div>
                  </td>
                  <td>
                    Surya Bakery evolved into A1 Bakery &amp; Sweets, reflecting our vision of becoming a premium regional brand.
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>2015</strong>
                    <div className="text-muted small">First Expansion</div>
                  </td>
                  <td>
                    We launched our first major branch at Peraiyur Mukku Salai, marking the beginning of our expansion.
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Today</strong>
                    <div className="text-muted small">15+ Branches</div>
                  </td>
                  <td>
                    A1 Bakery &amp; Sweets has expanded to 15+ branches across Madurai and Virudhunagar, including our successful Kalavasal franchise.
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <div className="container mt-50 mb-70">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="card border-0 shadow-sm rounded-4 p-4 p-lg-5 bg-white">
                  <div className="row align-items-center g-4 g-lg-5">
                    <div className="col-lg-5 text-center">
                      <div className="position-relative d-inline-block">
                        <img
                          src="/assets/img/a1-img/about__us/founder.png"
                          alt="The Founder — Sweet Subbu"
                          className="img-fluid rounded-4 shadow-sm"
                          style={{
                            maxHeight: "440px",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="mb-4">
                        <span className="text-danger fw-bold text-uppercase small tracking-wider">
                          The Visionary Behind A1
                        </span>
                        <h2 className="fw-bold text-dark mt-1 mb-3 fs-2">
                          The Founder — Sweet Subbu
                        </h2>
                        <p className="text-secondary mb-0" style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
                          Sweet Subbu is the visionary behind A1 Bakery &amp; Sweets and a proud first-generation entrepreneur. Built on determination, resilience, and relentless hard work, his journey transformed a single neighborhood bakery into a respected multi-branch brand. His unwavering belief in quality, customer satisfaction, and continuous growth remains the driving force behind every A1 Bakery &amp; Sweets outlet today.
                        </p>
                      </div>

                      <div className="p-4 bg-light rounded-4 border-start border-danger border-4 mt-4">
                        <h4 className="fw-bold text-dark mb-2 fs-4">
                          Our Vision
                        </h4>
                        <p className="text-secondary mb-3" style={{ fontSize: "1rem", lineHeight: "1.75" }}>
                          To make A1 Bakery &amp; Sweets one of Tamil Nadu's leading bakery and sweets brands by delivering premium-quality products and exceptional service at affordable prices. We believe that quality should be accessible to everyone, regardless of their background or income.
                        </p>
                        <p className="text-secondary mb-0" style={{ fontSize: "1rem", lineHeight: "1.75" }}>
                          Driven by social responsibility, we are committed to serving every community with honesty, consistency, and care while expanding our presence across Tamil Nadu and building a brand trusted for excellence by every family.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section
            className="video-section-full mb-80"
            onClick={handleTogglePlay}
          >
            <video
              ref={videoRef}
              preload="metadata"
              autoPlay
              muted
              playsInline
              loop
              onEnded={() => setIsPlaying(false)}
            >
              <source
                src="https://res.cloudinary.com/dsdxwhpuu/video/upload/q_auto/f_auto/v1779610510/A1_Simmakal_Opening_Vd_amyxva.mp4"
                type="video/mp4"
              />
              Sorry, your browser doesn’t support embedded videos.
            </video>
          </section>

          <section className="map__section section-padding-40 mb-30">
            <div className="container">
              <ProductSectionHeader
                title="Visit Our Stores"
                subtitle="We are closer than you think. Walk in to experience the aroma of fresh baking."
                viewAllLink="/contact-us"
              />

              <div className="row">
                <div className="col-12">
                  <div className="bd-product__wrapper p-relative">
                    <div className="bd-map-active swiper-container">
                      <div className="swiper-wrapper">
                        {storeLocations.map((item, index) => (
                          <div className="swiper-slide h-auto" key={index}>
                            <div className="card h-100 border-0 rounded-4 overflow-hidden d-flex flex-column">
                              <div
                                className="map__img-container position-relative overflow-hidden"
                                style={{ height: "230px" }}
                              >
                                <img
                                  className="card-img-top object-fit-cover"
                                  src={item.img}
                                  alt={item.name}
                                />

                                {item.district && (
                                  <span className="position-absolute top-0 start-50 translate-middle-x map-badge">
                                    {item.district}
                                  </span>
                                )}
                              </div>

                              <div className="card-body p-4 d-flex flex-column">
                                <h4 className="card-title fw-bold text-uppercase text-dark">
                                  {item.name}
                                </h4>

                                <hr />

                                <div className="flex-grow-1">
                                  <div className="d-flex gap-2 mb-3">
                                    <p className="medium mb-0">{item.address}</p>
                                  </div>
                                </div>

                                <div className="row g-2 mb-3">
                                  <div className="col-6">
                                    <a
                                      href={`tel:${item.phone}`}
                                      className="h-100 p-2 bg-light border-0 rounded-3 d-flex align-items-center justify-content-center gap-2 text-decoration-none text-dark"
                                      style={{
                                        minHeight: "55px",
                                        backgroundColor: "#f8f9fa",
                                      }}
                                      title={`Call ${item.name}`}
                                    >
                                      <i className="fa-solid fa-phone text-danger"></i>
                                      <span className="fw-semibold small">
                                        {item.phone}
                                      </span>
                                    </a>
                                  </div>

                                  <div className="col-6">
                                    <div
                                      className="h-100 p-2 border-0 rounded-3 d-flex align-items-center justify-content-center gap-2"
                                      style={{
                                        minHeight: "55px",
                                        backgroundColor: "#f8f9fa",
                                      }}
                                    >
                                      <i className="fa-solid fa-clock text-danger"></i>
                                      <span className="fw-semibold small">
                                        {item.timing}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="mt-3">
                                  <a
                                    href={item.link}
                                    className="bm-hero__cta w-100 text-center m-0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Get Directions
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="bd-product__nav">
                      <button className="map-button-prev">
                        <i className="fa-regular fa-angle-left"></i>
                      </button>
                      <button className="map-button-next">
                        <i className="fa-regular fa-angle-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <div className="feature-container">
              <div className="feature-item">
                <img
                  src="/assets/img/a1-img/dash__elements/fe-1.png"
                  className="feature-icon"
                  alt=""
                />
                <div className="feature-title">Business Model</div>
                <div className="feature-desc">
                  Re-Investment Of Profit Back Into Business.
                </div>
              </div>

              <div className="feature-item">
                <img
                  src="/assets/img/a1-img/dash__elements/fe-2.png"
                  className="feature-icon"
                  alt=""
                />
                <div className="feature-title">Double Employee</div>
                <div className="feature-desc">
                  We Train And Keep Best The Skill &amp; Soul Of Our 350 Employees
                </div>
              </div>

              <div className="feature-item">
                <img
                  src="/assets/img/a1-img/dash__elements/fe-3.png"
                  className="feature-icon"
                  alt=""
                />
                <div className="feature-title">Nutritional Concious</div>
                <div className="feature-desc">
                  To Boost Immunity People Started To Look For Nutritional
                  Diets.
                </div>
              </div>

              <div className="feature-item">
                <img
                  src="/assets/img/a1-img/dash__elements/fe-4.png"
                  className="feature-icon"
                  alt=""
                />
                <div className="feature-title">New Creations, Every Year</div>
                <div className="feature-desc">
                  Each Year, We Introduce A New Product.
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
        <FloatingWidgets />
      </div>
    </>
  );
}
